import PropTypes from 'prop-types'

export default PropTypes.oneOfType([
  PropTypes.objectOf(PropTypes.func),
])
